import { forwardRef } from "react"
import { PolymorphicBox, BoxProps } from "./types"

/**
 * Creates a component which is strongly typed depending on the "as" prop.
 *
 * E.g. when as="a", the href prop will have type `string | undefined`.
 * When as="button", the href prop will not be allowed
 */
export const Box: PolymorphicBox = forwardRef<unknown, unknown>((props, ref) => {
  // Speed up the typechecking by using any here. Users will only access the typing of PolymorphicBox
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { as, children, ...rest } = props as BoxProps<any>
  const Element = as || "div"
  return (
    <Element ref={ref} {...rest}>
      {children}
    </Element>
  )
})
